import SecureLS from "secure-ls";

export function SalvarEnderecoClienteNoNavegador(cep, uf, cidade_nome, bairro_id, bairro_nome, endereco_nome, numero, complemento)
{
  var ls = new SecureLS();
  var enderecos = ls.get('enderecos');
  var endereco = {
    cep: cep,
    uf: uf,
    cidade_nome: cidade_nome,
    bairro_id: bairro_id,
    bairro_nome: bairro_nome,
    endereco: endereco_nome,
    numero: numero,
    complemento: complemento
  }
  if(enderecos)
  {
    enderecos.push(endereco);
    ls.set('enderecos',enderecos);
  }else{
    enderecos = [];
    enderecos.push(endereco);
    ls.set('enderecos',enderecos);
  }
}

export function SalvarInformacoesDoClienteNoNavegador(nome_cliente, telefone, cpf_nota, cpf, pais_telefone)
{
  var ls = new SecureLS();
  
  // Ensure pais_telefone is just the code string, not an object
  const codigoPais = typeof pais_telefone === 'object' ? pais_telefone.codigo_area || pais_telefone.pais_telefone : pais_telefone;
  
  // Remove any existing country code from the start of the phone number
  let telefoneProcessado = telefone;
  if (codigoPais && telefoneProcessado.startsWith(codigoPais)) {
    telefoneProcessado = telefoneProcessado.substring(codigoPais.length);
  }
  
  ls.set('dados_cliente', {
    nome_cliente: nome_cliente,
    telefone: telefoneProcessado, // Save without country code prefix
    cpf_nota: cpf_nota,
    cpf: cpf,
    pais_telefone: codigoPais // Save just the country code
  });
  // console.log('dados_salvos', ls.get('dados_cliente'));
}




// WEBPACK FOOTER //
// ./src/services/storage.js